/**
 * Partner referral codes (BOT-1774). A partner link carries ?referrer=<code>; the
 * code is kept for 30 days in a first-party cookie on .bottle.com so www (Webflow)
 * and the dashboard share it, and is sent with the signup.
 *
 * Shared by server.js (prod Express), vue.config.js (dev server) and the app.
 * Safari caps cookies set from JavaScript at 7 days, so the server sets the
 * cookie again as a real Set-Cookie whenever it sees the param or the cookie.
 */
const REFERRER_PARAM = 'referrer'
const REFERRER_COOKIE = 'bottle_referrer'
const REFERRER_MAX_AGE_DAYS = 30
const REFERRER_CODE_FORMAT = /^[a-z0-9][a-z0-9_-]{1,63}$/
const SHARED_COOKIE_DOMAIN = '.bottle.com'

function normalizeReferralCode(value) {
  const single = Array.isArray(value) ? value[0] : value
  if (typeof single !== 'string') return null
  const code = single.trim().toLowerCase()
  return REFERRER_CODE_FORMAT.test(code) ? code : null
}

function cookieDomainFor(hostname) {
  const host = String(hostname || '').toLowerCase()
  return host === 'bottle.com' || host.endsWith(SHARED_COOKIE_DOMAIN) ? SHARED_COOKIE_DOMAIN : undefined
}

function readCookie(header, name) {
  const pair = String(header || '')
    .split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(`${name}=`))
  if (!pair) return null
  try {
    return decodeURIComponent(pair.slice(name.length + 1))
  } catch {
    return null
  }
}

function serializeReferrerCookie(code, { domain, secure }) {
  return [
    `${REFERRER_COOKIE}=${encodeURIComponent(code)}`,
    'Path=/',
    `Max-Age=${REFERRER_MAX_AGE_DAYS * 24 * 60 * 60}`,
    'SameSite=Lax',
    domain && `Domain=${domain}`,
    secure && 'Secure'
  ]
    .filter(Boolean)
    .join('; ')
}

function isPageRequest(req) {
  return req.method === 'GET' && String(req.headers.accept || '').includes('text/html')
}

function isSecure(req) {
  return req.secure || req.headers['x-forwarded-proto'] === 'https'
}

function referrerCookie(req, res, next) {
  if (isPageRequest(req)) {
    const code =
      normalizeReferralCode(req.query && req.query[REFERRER_PARAM]) ||
      normalizeReferralCode(readCookie(req.headers.cookie, REFERRER_COOKIE))
    if (code) {
      res.append(
        'Set-Cookie',
        serializeReferrerCookie(code, { domain: cookieDomainFor(req.hostname), secure: isSecure(req) })
      )
    }
  }
  next()
}

module.exports = {
  REFERRER_PARAM,
  REFERRER_COOKIE,
  REFERRER_MAX_AGE_DAYS,
  normalizeReferralCode,
  cookieDomainFor,
  readCookie,
  serializeReferrerCookie,
  referrerCookie
}
